module.exports = __webpack_public_path__ + "img/point.a5f748d6.svg";